export default {
      id: "att-current-usage",
      viewBox: "0 0 70 70",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#att-current",
      toString: function () {
        return this.url;
      }
    }